export function formatNumberLocale(value: number | bigint, options?: Intl.NumberFormatOptions): string {
  try {
    return new Intl.NumberFormat(undefined, options).format(value)
  } catch (error) {
    console.error('Error formatting number with options:', error)
    return String(value)
  }
}

// format function for duration (2h, 12d) to hours (2, 288)
export function formatDurationToHours(duration: string): number {
  const hoursInDay = 24
  const value = parseInt(duration, 10)
  if (duration.endsWith('h')) {
    return value
  } else if (duration.endsWith('d')) {
    return value * hoursInDay
  }
  return value // default to hours if no unit is provided
}

// format function for duration 1d to 1 Day, 2h to 2 Hours
export function formatDurationLabel(duration: string): string {
  if (!duration) return ''

  const value = parseInt(duration, 10)
  if (duration.endsWith('h')) {
    return `${value} Hour${value !== 1 ? 's' : ''}`
  } else if (duration.endsWith('d')) {
    return `${value} Day${value !== 1 ? 's' : ''}`
  }
  return `${value} Hour${value !== 1 ? 's' : ''}` // default to hours if no unit is provided
}
